module.exports = __webpack_public_path__ + "img/sync-green.eabb7e93.svg";